import { post } from './apiUtils';

const defaultUrl = '/CompaniesDistributionChannels/';

export default {
  saveCompanyDistributionChannel: data => post(defaultUrl, data),
};
